export default __webpack_public_path__ + "static/ck-d9461e6f11c5a4bc7fab043ba1f36a04.svg";